import { CAL_SEGMENT_SCENE_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: CAL_SEGMENT_SCENE_MNG,
  params: null,
  view: {
    title: '创建细分场景',
    labelPosition: 'right',
    content: [
      {
        $id: 'segmentName',
        $type: 'input',
        label: '细分场景名称',
        $el: {
          placeholder: '请输入细分场景名称',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: '细分场景名称'
          }
        ]
      },
      {
        $id: 'description',
        $type: 'input',
        label: '场景特征描述',
        $el: {
          placeholder: '请输入场景特征描述',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 5
        },
        rules: [
          {
            notEmpty: '场景特征描述'
          }
        ]
      },
      {
        $id: 'specCalDesktopElementArr',
        label: '关联桌面元素',
        $type: 'sky-relation-option',
        actions: {
          nativeOn: {
            click: 'segmentSceneRelaDesktopElement'
          }
        },
        $el: {
          multiple: true
        },
        rules: [{ notEmpty: '关联桌面元素' }]
      },
      {
        $id: 'specCalServerElementDTOList',
        $type: 'sky-cal-server-element',
        label: '服务器元素',
        rules: [
          {
            notEmpty: '服务器元素'
          }
        ]
      },
      {
        $id: 'specCalServerDTOList',
        $type: 'sky-cal-server',
        label: '推荐服务器',
        rules: [
          {
            notEmpty: '推荐服务器'
          }
        ]
      }
      // {
      //   $id: 'compatibleDTOList',
      //   $type: 'sky-product-os-relate',
      //   label: '服务器元素',
      //   rules: [
      //     {
      //       // notEmpty: '支持的产品及操作系统'
      //     }
      //   ]
      // },
      // {
      //   $id: 'compatibleDTOList',
      //   $type: 'sky-product-os-relate',
      //   label: '服务器推荐',
      //   rules: [
      //     {
      //       // notEmpty: '支持的产品及操作系统'
      //     }
      //   ]
      // }
    ]
  }
}
